import React from 'react';
import { translate } from '../Services/translation';

import PropTypes from 'prop-types';

const newAddressFields = [
  {
    id: 'address',
    key: 'alternativeCompanyAddress',
  },
  {
    id: 'careOf',
    key: 'alternativeCompanyAddress',
  },
  {
    id: 'zipCode',
    key: 'alternativeCompanyAddress',
  },
  {
    id: 'city',
    key: 'alternativeCompanyAddress',
  },
];

const CheckoutBusinessCustomerInfo = (props) => {
  const {
    checkout,
    orderNote,
    setOrderNote,
    authenticated,
    onChange,
    companyAddresses,
  } = props;

  const { payload = {}, errors = {} } = checkout || {};
  const { isAlternativeCompanyAddressAllowed } = payload || {};

  const options = companyAddresses.map(({ address, systemId }) => (
    <option value={systemId} key={systemId}>
      {address}
    </option>
  ));
  const select = (cssClass) => (
    <div className={cssClass}>
      <select
        className="form__input"
        onChange={(event) =>
          onChange('companyAddress', 'systemId', event.target.value)
        }
      >
        {options}
      </select>
    </div>
  );
  const input = (cssClass, stateKey, id, autoComplete = null, type = 'text') => (
    <div className={cssClass} key={`${stateKey}_${id}`}>
      <input
        className="form__input"
        disabled={!authenticated}
        id={`${stateKey}-${id}`}
        name={`${stateKey}-${id}`}
        type={type}
        value={(payload[stateKey] || {})[id] || ''}
        placeholder={translate(`checkout.customerinfo.${id.toLowerCase()}`)}
        autoComplete={autoComplete}
        onChange={(event) => onChange(stateKey, id, event.target.value)}
      />
      {errors[`${stateKey}-${id}`] && (
        <span
          className="form__validator--error form__validator--top-narrow"
          data-error-for={`${stateKey}-${id}`}
        >
          {errors[`${stateKey}-${id}`][0]}
        </span>
      )}
    </div>
  );
  return (
    <div className="row checkout-info__container">
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'firstName',
        'billing given-name'
      )}
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'lastName',
        'billing family-name'
      )}
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'phoneNumber',
        'billing tel'
      )}
      {input('small-12 medium-6 columns', 'customerDetails', 'email', 'email')}
      {input(
        'small-12 columns',
        'customerDetails',
        'customerOrderNumber',
        'billing customer-order-number'
      )}

      {!isAlternativeCompanyAddressAllowed ? select('small-12 columns') : null}

      {isAlternativeCompanyAddressAllowed
        ? newAddressFields.map(({ id, key }) =>
            input('small-12 medium-6 columns', key, id, null, 'text')
          )
        : null}

      <div className="columns small-12 checkout-info__summary--full-height">
        <textarea
          className="form__input checkout-info__messages"
          value={orderNote}
          onChange={(event) => setOrderNote(event.target.value)}
          placeholder={translate('checkout.order.message')}
        ></textarea>
      </div>
    </div>
  );
};

CheckoutBusinessCustomerInfo.propTypes = {
  checkout: PropTypes.object,
  orderNote: PropTypes.string,
  setOrderNote: PropTypes.func,
  authenticated: PropTypes.bool,
  onChange: PropTypes.func,
  companyAddresses: PropTypes.array,
  errors: PropTypes.object,
};

export default CheckoutBusinessCustomerInfo;
